export type SalesDataClientSourceCancelTaskPayload = {
  licenseId: number
  monthlyAnalyticsId: number
}
